import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

// Initialize FireBase. Replace this with your own config details
const config = {
  apiKey: "AIzaSyAgJRJS6jD0RdohFFRjVDMRw6W77XtzoK8",
  authDomain: "working-groups.firebaseapp.com",
  databaseURL: "https://working-groups.firebaseio.com",
  projectId: "working-groups",
  storageBucket: "working-groups.appspot.com",
  messagingSenderId: "185069574719"
};

firebase.initializeApp(config);
firebase.firestore().settings({ timestampsInSnapshots: true });

export default firebase;
